import { Button, FormControl, FormControlLabel, Grid, IconButton, makeStyles, Menu, MenuItem, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from "@material-ui/core";
import Collapse from '@material-ui/core/Collapse';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import AddIcon from '@material-ui/icons/Add';
import ClearIcon from '@material-ui/icons/Clear';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { DatePicker } from "@material-ui/pickers";
import { withStyles } from "@material-ui/styles";
import clsx from 'clsx';
import AdminTitle from "components/admin/smart-visa/AdminTitle";
import AdminTitle2 from "components/admin/smart-visa/AdminTitle2";
import { StyleCheckbox } from "components/request-document/components/Commons";
import { format } from "date-fns";
import { boiDepartmentId } from "libs/configs/constant";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addUserActions, getConfigActionListDirector, getUserActionsForDirector } from "redux/modules/configActionSlice";
import { getEmployeeList } from "redux/modules/employeeSlice";


const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    padding: 0,
    paddingLeft: theme.spacing(4),
  },
  warpDialog: {

    padding: "30px", minWidth: "600px", minHeight: "200px"
  },
  paper: {
    padding: theme.spacing(4),
    borderRadius: 16,
  },
  content: {
    marginTop: 30
  },
  warpSubHeader: {
    marginTop: 20,
    display: "flex", justifyContent: "end", alignItems: "center"
  },
  buttonDialogSave: {
    width: '100%',
    margin: '15px 5px'
  },
  table: {
    minWidth: 700,
  },
  tableHead: {
    backgroundColor: '#F1F3F9',
    color: '#8898AA',
    textAlign: 'center'
  },

  warpButtonDetail: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  center: {
    textAlign: 'center'
  },
  btnActive: {
    color: '#2DCE98',
    border: '1px solid #2DCE98',
    backgroundColor: ' white',
    marginRight: 10,
    width: 75
  },
  btnInActive: {
    color: '#F53C56',
    border: '1px solid #F53C56',
    backgroundColor: ' white',
    marginRight: 10,
    width: 75
  },
  dtitle: {
    color: '#40B8D4',
  },
  d2title: {
    color: '#172B4D',
    paddingBottom: 10

  },
  textDialog: {
    width: '100%',
  },
  warpButtonDialogSave: {
    display: 'flex'
  },
  warpRowDialog: {
    marginTop: 10
  },
  warpRowDateDialog: {
    display: 'flex'
  },
  formControl: {
    width: '100%'
  },
  warpFormControl: {
    paddingLeft: 10,
    paddingRight: 10
  },
  buttonStatusDetail: {
    cursor: 'pointer'
  },
  titleDialog: {
    color: "#172B4D", fontSize: "20px", fontWeight: "500", marginTop: 15
  },
  fullformControl: {
    width: '100%'
  },
  btnRemove: {
    color: 'white',
    backgroundColor: '#F53C56'
  },
  item: {
    padding: 0
  },
  wrapDateControl: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'end',
    marginBottom: 15
  },
  dateControl: {
    marginRight: 5,
    width: '100%'
  }
}));




function PermissionPage() {

  const classes = useStyles();
  const dispatch = useDispatch();

  const { list: employees } = useSelector((state) => state.employee);
  const { directorlist, userActions } = useSelector((state) => state.configAction);


  const [startDate, setStartDate] = React.useState(null);
  const [endDate, setEndDate] = React.useState(null);
  const [filterEmp, setFilterEmp] = React.useState(employees);
  const [filterdirectorlist, setFilterdirectorlist] = React.useState(directorlist);
  const [serachAction, setSerachAction] = React.useState('');

  const [actionList, setActionList] = React.useState(userActions);

  const options = [
    'แก้ไข',
    'ลบพนักงาน',
    'ไม่กำหนดเวลา',
  ];

  useEffect(() => {
    setFilterEmp(employees)
    setFilterdirectorlist(directorlist)
    setActionList(userActions)
  }, [employees, directorlist, userActions]);


  useEffect(async () => {

    const body = {
      departmentId: boiDepartmentId
    }
    await dispatch(getEmployeeList(body));
    await dispatch(getConfigActionListDirector({ isCustom: 'true' }));
    await dispatch(getUserActionsForDirector());

  }, []);


  const handleAddSurrogate = async (value) => {

    const emps = filterEmp.filter(x => x.selected);
    const actions = []
    filterdirectorlist.forEach(m => {
      m.subMenu.forEach(a => {
        actions.push(...a.actionMenu.filter(x => x.selected));
      })
    })

    const body = [];

    emps.forEach(e => {
      actions.forEach(a => {
        body.push({
          configId: null,
          userId: e.empId,
          actionNo: a.actionNo,
          status: 'Y',
          startDate: startDate,
          endDate: endDate
        });
      });
    })

    await dispatch(addUserActions(body));
    await dispatch(getUserActionsForDirector());
  }




  const [anchorEl, setAnchorEl] = React.useState(null);
  const openMenu = Boolean(anchorEl);

  return (
    <Paper className={classes.paper}>
      <AdminTitle title="Setting" subTitle="สิทธิ์การเข้าถึง" />

      <div className={classes.warpSubHeader} >

        <div className={classes.wrapDateControl}>
          <FormControl variant="outlined" className={clsx(classes.dateControl)} >
            {/* <InputLabel>Start Date</InputLabel> */}
            < DatePicker
              className={classes.formControl}
              inputVariant="outlined"
              openTo="year"
              format="DD-MM-YYYY"
              label="Start Date"
              views={["year", "month", "date"]}
              name={`startDate`}
              value={startDate}
              onChange={(date) => {
                setStartDate(date.format("YYYY-MM-DD"))
              }}
              InputProps={{
                endAdornment: (

                  startDate && (
                    <IconButton onClick={(e) => {
                      e.stopPropagation();
                      setStartDate(null)
                    }}>
                      <ClearIcon />
                    </IconButton>
                  )
                )
              }}

            />
          </FormControl>
          <FormControl variant="outlined" className={clsx(classes.dateControl)} >
            {/* <InputLabel>Start Date</InputLabel> */}
            < DatePicker
              className={classes.formControl}
              inputVariant="outlined"
              openTo="year"
              format="DD-MM-YYYY"
              label="End Date"
              views={["year", "month", "date"]}
              name={`endDate`}
              value={endDate}
              onChange={(date) => {
                setEndDate(date.format("YYYY-MM-DD"))
              }}
              InputProps={{
                endAdornment: (

                  endDate && (
                    <IconButton onClick={(e) => {
                      e.stopPropagation();
                      setEndDate(null)
                    }}>
                      <ClearIcon />
                    </IconButton>
                  )
                )
              }}
            />
          </FormControl>

          <Button variant="contained" size="medium" color="primary" onClick={() => handleAddSurrogate()} className={classes.buttonDialogSave}>
            <AddIcon />
            เพิ่มสิทธิ์
          </Button>
        </div>

      </div >
      <div>
        <Grid container className={classes.wrapTransferRow} spacing={3}>

          <Grid item xs={12} sm={6} className={classes.wrapTransfer}>

            <FormControl variant="outlined" className={classes.fullformControl}>
              <TextField
                type="text"
                variant="outlined"
                className={classes.textField}
                placeholder="ค้นหาพนักงาน"
                fullWidth
                onChange={(event) => {
                  const arr = employees.filter(x =>
                    x.employeeFistName.toLowerCase().indexOf(event.target.value.toLowerCase()) > -1 ||
                    x.employeeLastName.toLowerCase().indexOf(event.target.value.toLowerCase()) > -1)
                  setFilterEmp(arr);
                }}
              />
            </FormControl>

            <div className={classes.titleDialog}>
              รายชื่อพนักงาน
            </div>

            <div>
              <List component="nav" aria-label="secondary mailbox folders">

                {
                  filterEmp.map((e, index) => (
                    <>
                      <ListItem button classes={{ root: classes.item }}>
                        <FormControlLabel
                          control={
                            <StyleCheckbox
                              onClick={(event) => {
                                const _emps = filterEmp.map((item, index2) => (index === index2) ? { ...item, selected: event.target.checked } : item)
                                setFilterEmp(_emps);
                              }}
                            />
                          }
                        />
                        <ListItemText primary={e.employeeFistName + ' ' + e.employeeLastName} />
                      </ListItem>
                      <Divider />
                    </>
                  ))
                }
              </List>
            </div>
          </Grid>

          <Grid item xs={12} sm={6} className={classes.wrapTransfer}>

            <FormControl variant="outlined" className={classes.fullformControl}>
              <TextField
                type="text"
                variant="outlined"
                className={classes.textField}
                onChange={(event) => {
                  setSerachAction(event.target.value);
                }}
                placeholder="ค้นหาสิทธิ์"
                fullWidth
              />
            </FormControl>

            <div className={classes.titleDialog}>
              สิทธิ์
            </div>

            <div>
              <List
                component="nav"
                aria-labelledby="nested-list-subheader"
                className={classes.root}
              >
                {
                  filterdirectorlist.map((m, index) => (
                    <>
                      <ListItem button onClick={(event) => {
                        const menu = filterdirectorlist.map((item, index2) => (index === index2) ? { ...item, show: !m.show } : item)
                        setFilterdirectorlist(menu);

                      }}>

                        <ListItemText primary={m.menuName} />
                        {!m.show ? <ExpandLess /> : <ExpandMore />}
                      </ListItem>
                      <Divider />
                      <Collapse in={!m.show} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>

                          {
                            m.subMenu.map(s => {
                              return s.actionMenu.filter(x => x.actionName.toLowerCase().indexOf(serachAction.toLowerCase()) > -1).map(a => (
                                <>
                                  <ListItem button className={clsx(classes.nested)}>
                                    <FormControlLabel
                                      control={
                                        <StyleCheckbox
                                          onClick={(event) => {
                                            const _actions = JSON.parse(JSON.stringify(filterdirectorlist));
                                            let _action = _actions.find(x => x.menuNo === m.menuNo)?.subMenu.find(x => x.subMenuNo === s.subMenuNo)?.actionMenu.find(x => x.actionNo === a.actionNo);
                                            if (_action) {
                                              _action.selected = event.target.checked;
                                            }
                                            setFilterdirectorlist(_actions);
                                          }}
                                        />
                                      }
                                    />
                                    <ListItemText primary={a.actionName} />
                                  </ListItem>
                                </>
                              ))
                            })
                          }
                        </List>
                      </Collapse>
                    </>
                  ))
                }

              </List>
            </div>
          </Grid>
        </Grid>
      </div>
      <div className={classes.warpSubHeader} style={{ 'justifyContent': 'space-between' }}>
        <AdminTitle2 subTitle="สิทธิ์การเข้าถึง" />

        <div>
          <FormControl variant="outlined" className={classes.formControl}>

            <TextField
              type="text"
              variant="outlined"
              placeholder="ค้นหา"
              className={classes.textField}
              onChange={(event) => {
                const arr = filterEmp.filter(x => x[0].indexOf(event.target.value) > -1)
                setFilterEmp(arr);
              }}
              name="emp_search"
            />
          </FormControl>
        </div>

      </div>
      <div className={classes.content}>
        <div className={classes.warpData}>
          <TableContainer>
            <Table className={classes.table} aria-label="customized table">
              <TableHead >
                <TableRow>
                  <StyledTableCell className={classes.tableHead}>#</StyledTableCell>
                  <StyledTableCell className={classes.tableHead}>First Name</StyledTableCell>
                  <StyledTableCell className={classes.tableHead}>Last Name</StyledTableCell>
                  <StyledTableCell className={classes.tableHead}>Position</StyledTableCell>
                  <StyledTableCell className={classes.tableHead}>Start Date</StyledTableCell>
                  <StyledTableCell className={classes.tableHead}>End Date</StyledTableCell>
                  <StyledTableCell className={classes.tableHead}>Module</StyledTableCell>
                  <StyledTableCell className={classes.tableHead}>Action</StyledTableCell>
                  <StyledTableCell className={classes.tableHead}>Remove</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {actionList?.map((row, index) => (
                  <StyledTableRow key={row.name}>
                    <StyledTableCell component="th" scope="row" className={classes.center}> {index + 1}</StyledTableCell>
                    <StyledTableCell className={classes.center}>{row.firstname}</StyledTableCell>
                    <StyledTableCell className={classes.center}>{row.lastname}</StyledTableCell>
                    <StyledTableCell className={classes.center}>{row.position}</StyledTableCell>
                    <StyledTableCell className={classes.center}>{row.startDate ? format(new Date(row.startDate), "yyyy-MM-dd") : null}</StyledTableCell>
                    <StyledTableCell className={classes.center}>{row.endDate ? format(new Date(row.endDate), "yyyy-MM-dd") : null}</StyledTableCell>
                    <StyledTableCell className={classes.center}>{row.menuName}</StyledTableCell>
                    <StyledTableCell className={classes.center}>{row.actionName}</StyledTableCell>
                    <StyledTableCell style={{ textAlign: 'center' }}>
                      <div className={classes.warpButtonDetail}>
                        <Button size="small" color="error" className={classes.btnRemove} onClick={async () => {
                          const body = [{
                            configId: row.configId,
                            userId: row.empId,
                            actionNo: row.actionNo,
                            status: 'N',
                            startDate: row.startDate,
                            endDate: row.endDate
                          }];

                          console.log(row);
                          console.log(body);
                          await dispatch(addUserActions(body));
                          await dispatch(getUserActionsForDirector());
                        }}>
                          ลบ
                        </Button>

                      </div>
                    </StyledTableCell>

                  </StyledTableRow>
                ))}

              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={openMenu}
        onClose={() => {
          setAnchorEl(null);
        }}
      >
        {options.map((option) => (
          <MenuItem key={option} selected={option === 'Pyxis'} onClick={() => {
            setAnchorEl(null);
          }}>
            {option}
          </MenuItem>
        ))}
      </Menu>
    </Paper >
  );
}

export default PermissionPage;
